import React from "react";
import { Download, FileSpreadsheet, FileText, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { exportToCSV, exportToXLSX } from "@/lib/export";
import { TID } from "@/lib/testIds";

export default function ExportMenu({ rows, disabled }) {
  const count = rows?.length || 0;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          disabled={disabled || count === 0}
          data-testid={TID.exportBtn}
          className="inline-flex items-center gap-1.5 h-8 px-2.5 rounded-lg border border-[#E2E8F0] bg-white text-xs font-medium text-[#334155] hover:border-[#CBD5E1] disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Download className="h-3.5 w-3.5" />
          Export
          <span className="text-[10px] text-[#94A3B8]">({count})</span>
          <ChevronDown className="h-3 w-3 text-[#94A3B8]" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-40 border-[#E2E8F0]"
      >
        <DropdownMenuItem
          onClick={() => exportToCSV(rows)}
          data-testid={TID.exportCsv}
          className="text-xs cursor-pointer"
        >
          <FileText className="h-3.5 w-3.5" />
          CSV (.csv)
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => exportToXLSX(rows)}
          data-testid={TID.exportXlsx}
          className="text-xs cursor-pointer"
        >
          <FileSpreadsheet className="h-3.5 w-3.5" />
          Excel (.xlsx)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
